import * as React from 'react';
import type { SVGProps } from 'react';

import { TI_PRO_TEXT_ACCENT_PATH_D, TI_PRO_TEXT_MAIN_PATH_D } from './logoPaths';

interface LogoTIProTextProps extends SVGProps<SVGSVGElement> {
  currentUserCode?: string;
  watermarkedPathD?: string;
}

const LogoTIProText = ({ currentUserCode, watermarkedPathD, ...svgProps }: LogoTIProTextProps) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1401 143" {...svgProps}>
    <path
      d={`${watermarkedPathD || TI_PRO_TEXT_MAIN_PATH_D} ${currentUserCode || ''}`}
      fill="currentColor"
    />
    <path d={`${TI_PRO_TEXT_ACCENT_PATH_D} ${currentUserCode || ''}`} fill="#C5A26D" />
  </svg>
);
export default LogoTIProText;
